import { uiblockerStyle } from '@bingads-webui-campaign-react/common-styles';

export const getUIBlockerStyle = ({ palette = {} }) => ({
  '@global': {
    ...uiblockerStyle({ palette }),

    '.blocker-container .blocker': {
      zIndex: 10000000, // Need a z-index higher than the z-index of Fluent UI Panel
    },
  },
});
